// Kargo adres seçici (Hepsijet) — GET /repair-request/cargo/cities,
// /cargo/cities/{cityId}/towns, /cargo/towns/{townId}/districts.
//
// Üç seviyenin de gövdesi aynı: { id, name }.

/** Seçicideki tek bir konum (il, ilçe veya semt). */
export interface CargoLocation {
  id: number;
  name: string;
}

/**
 * Talep gövdesine yazılacak kargo adresi.
 *
 * `id` alanları YALNIZCA bir sonraki dropdown'ı çağırmak için tutulur; talebe
 * `name` değeri **birebir** gider. Backend Hepsijet listesiyle `Ordinal`
 * karşılaştırdığı için ilçe adları BÜYÜK HARF gelir (`KADIKÖY`), il adı gelmez
 * (`İstanbul`) — hiçbirine `toUpperCase()`/`toLocaleLowerCase()` uygulanmamalı,
 * aksi halde backend 400 döner.
 */
export interface CargoAddress {
  city: CargoLocation | null;
  town: CargoLocation | null;
  /** Semt opsiyonel: bazı ilçelerde seçici boş liste dönebiliyor. */
  district: CargoLocation | null;
  addressLine: string;
}

export const EMPTY_CARGO_ADDRESS: CargoAddress = {
  city: null,
  town: null,
  district: null,
  addressLine: '',
};

/** Backend doğrulaması: açık adres en fazla 500 karakter. */
export const CARGO_ADDRESS_LINE_MAX = 500;

/**
 * Cihazın atölyeye nasıl ulaşacağı.
 *
 * Şu an TEK yöntem var: kurye cihazı adresten alır. Talep gövdesinde
 * (`CreateRepairRequestCommand`) yöntem alanı yok, müşterinin paketi kendi
 * bırakması diye bir akış da yok. Seçim ekranı yine de duruyor ve tek kart
 * gösteriyor: yeni bir yöntem geldiğinde union'a bir değer, seçiciye de bir
 * kart eklemek yetsin diye.
 */
export type ShippingMethod = 'pickup';

export const DEFAULT_SHIPPING_METHOD: ShippingMethod = 'pickup';
